// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-HeadsUpHelper {\n  position: absolute;\n  z-index: 100;\n  left: 280px;\n}\n.x-HeadsUpHelper:empty {\n  border: 0;\n}\n", "",{"version":3,"sources":["webpack://./web/app/cad/dom/components/HeadsUpHelper.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AACF;AAEA;EACE,SAAA;AAAF","sourcesContent":[".root {\n  position: absolute;\n  z-index: 100;\n  left: 280px;\n}\n\n.root:empty {\n  border: 0;  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "x-HeadsUpHelper"
};
export default ___CSS_LOADER_EXPORT___;
